<template>
  <div class="ti">
    <div style="display: flex">
      <el-card class="box-card" style="width: 48%">
        <div slot="header" class="clearfix">
          <span class="file_size">应收款报表</span>
        </div>
        <router-link to="/Forms/receivables"
          ><div class="text item"><li>应收款明细表</li></div></router-link
        >
        <router-link to="/Forms/noticeOfPayment"
          ><div class="text item"><li>缴费通知单</li></div></router-link
        >
        <router-link to="/Forms/receivablesUpdate"
          ><div class="text item"><li>应收款变动明细表</li></div></router-link
        >
      </el-card>
      <el-card class="box-card" style="width: 48%; margin-left: 1%">
        <div slot="header" class="clearfix">
          <span class="file_size">已缴款报表</span>
        </div>
        <router-link to="/Forms/chargeDetail">
          <div class="text item"><li>收款明细（汇总）表</li></div>
        </router-link>
        <router-link to="/Forms/collectMoney">
          <div class="text item"><li>收款明细表</li></div>
        </router-link>
        <router-link to="/OrderDaily/list">
          <div class="text item"><li>收银日报表</li></div>
        </router-link>
        <router-link to="/OrderDaily/DailyCompare">
          <div class="text item"><li>每日收入对账表</li></div>
        </router-link>
        <router-link to="/OrderDaily/PosCharge">
          <div class="text item"><li>智能POS对账表</li></div>
        </router-link>
      </el-card>
    </div>

    <div style="display: flex; margin-top: 1%">
      <el-card class="box-card" style="width: 48%">
        <div slot="header" class="clearfix">
          <span class="file_size">欠费报表</span>
        </div>
        <router-link to="/Forms/oweMoney">
          <li class="text item">欠费账龄按户统计明细表</li>
        </router-link>
        <router-link to="/Forms/financialAgeAnalysisStatement">
          <div class="text item">
            <li>欠费账龄绩效统计表</li>
          </div>
        </router-link>
        <router-link to="/Forms/historyFinancialAge">
          <div class="text item">
            <li>历史账龄收缴率报表</li>
          </div>
        </router-link>
        <router-link to="/Forms/withdrawFinancial">
          <div class="text item">
            <li>撤场项目收费统计表</li>
          </div>
        </router-link>
        <router-link to="/Forms/paymentRateStatement">
          <div class="text item">
            <li>在管项目收缴率统计报表</li>
          </div>
        </router-link>
        <!-- <router-link to="/Forms/dailyStatement">
          <div class="text item">
            <li>现金流收支情况日报表</li>
          </div>
        </router-link> -->
        <router-link to="/Forms/oweCheck">
          <li class="text item">系统欠费检、抽查记录表</li>
        </router-link>
      </el-card>
      <el-card class="box-card" style="width: 48%; margin-left: 1%">
        <div slot="header" class="clearfix">
          <span class="file_size">费用汇总报表</span>
        </div>
        <router-link to="/Forms/chargeSum"
          ><div class="text item"><li>收费汇总表</li></div></router-link
        >
        <router-link to="/Forms/minusMoney"
          ><div class="text item">
            <li>费用减免汇总表（明细）</li>
          </div></router-link
        >
        <router-link to="/Forms/projectDeductions">
          <div class="text item">
            <li>项目减免汇总表</li>
          </div>
        </router-link>
        <router-link to="/Forms/reductionsAdjustments">
          <div class="text item">
            <li>系统减免及调整汇总表</li>
          </div>
        </router-link>
      </el-card>
    </div>
    <div style="display: flex; margin-top: 1%">
      <el-card class="box-card" style="width: 48%">
        <div slot="header" class="clearfix">
          <span class="file_size">预收款报表</span>
        </div>
        <router-link to="/Forms/advancesDetail"
          ><div class="text item"><li>预收账款汇总表</li></div></router-link
        >
        <router-link to="/Forms/advances"
          ><div class="text item">
            <li>客户预收款余额明细表</li>
          </div></router-link
        >
        <router-link to="/Forms/advanceList"
          ><div class="text item">
            <li>客户预收款变动明细表</li>
          </div></router-link
        >
        <router-link to="/Forms/advancesCollect"
          ><div class="text item"><li>预收款汇总表</li></div></router-link
        >
        <!-- <router-link to="/Forms/advancesUpdate"><div class="text item"><li>客户预收款变动明细表</li></div></router-link> -->
      </el-card>
      <el-card class="box-card" style="width: 48%; margin-left: 1%">
        <div slot="header" class="clearfix">
          <span class="file_size">押金报表</span>
        </div>
        <router-link to="/Forms/deposit"
          ><div class="text item"><li>客户押金余额明细表</li></div></router-link
        >
        <router-link to="/Forms/depositUpdate"
          ><div class="text item"><li>客户押金变动明细表</li></div></router-link
        >
        <router-link to="/Forms/depositSummarySheet"
          ><div class="text item"><li>押金汇总表</li></div></router-link
        >
      </el-card>
    </div>
    <div style="display: flex; margin-top: 1%">
      <el-card class="box-card" style="width: 48%">
        <div slot="header" class="clearfix">
          <span class="file_size">驾驶舱报表</span>
        </div>
        <router-link to="/Forms/AgingStatistics">
          <div class="text item"><li>账龄分析</li></div>
        </router-link>
      </el-card>
      <el-card class="box-card" style="width: 48%; margin-left: 1%">
        <div slot="header" class="clearfix">
          <span class="file_size">审计报表</span>
        </div>
        <router-link to="/Forms/auditReport">
          <div class="text item">
            <li>审计口径历史欠费余额变动表</li>
          </div>
        </router-link>
        <router-link to="/Forms/auditChargeSum">
          <div class="text item">
            <li>审计口径收费汇总表</li>
          </div>
        </router-link>
        <router-link to="/Forms/advancesDetail">
          <div class="text item">
            <li>预收账款汇总表</li>
          </div>
        </router-link>
        <router-link to="/Forms/receivablesUpdate">
          <div class="text item">
            <li>应收款变动明细表</li>
          </div>
        </router-link>
        <router-link to="/Forms/oweMoney">
          <li class="text item">欠费账龄按户统计明细表</li>
        </router-link>
        <router-link to="/Forms/reductionsAdjustments">
          <div class="text item">
            <li>系统减免及调整汇总表</li>
          </div>
        </router-link>
        <router-link to="/Forms/ChargeSumTrue">
          <div class="text item">
            <li>收费汇总表_新物业费</li>
          </div>
        </router-link>
      </el-card>
    </div>
    <!-- <div style="display: flex; margin-top: 1%">
      <el-card class="box-card" style="width: 48%">
        <div slot="header" class="clearfix">
          <span class="file_size">账龄分析报表</span>
        </div>
      </el-card>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "FormsOrderList",
  data() {
    return {};
  },
  //界面没出来前加载
  created() {},
  // 加载数据
  mounted() {},
  computed: {
    __TABLE_HEIGHT__() {
      return ERP.getStore().__TABLE_HEIGHT__;
    },
  },
  //事件
  methods: {},
};
</script>
<style scoped>
.ti {
  margin: 1%;
  width: 98%;
}
.text1 {
  text-align: center;
}
.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2 {
  color: rgb(250, 248, 248);
}
.kuan {
  width: 10%;
}
.zhanwu {
  text-align: center;
  color: rgb(247, 243, 243);
  font-size: 20px;
  margin-top: 3%;
}
.item {
  color: #000000;
}
</style>
<style>
.el-upload--picture-card {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100px;
  height: 100px;
  line-height: 100px;
  vertical-align: top;
}
.el-upload-list--picture-card .el-upload-list__item {
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100px;
  height: 100px;
  margin: 0 8px 8px 0;
  display: inline-block;
}
.file_size {
  font-size: 15px;
  font-weight: normal;
  font-weight: bold;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Forms/orderList.vue